import React, { useState } from "react";

const CorreoManager = ({ correosString, onSave }) => {
  // Paso 2: Convertir el string en un array de objetos
  const [correos, setCorreos] = useState(
    correosString.split(";").map((correo) => ({ correo: correo.trim() }))
  );
  
  const [nuevoCorreo, setNuevoCorreo] = useState("");

  // Paso 3: Función para eliminar un correo
  const eliminarCorreo = (correo) => {
    setCorreos(correos.filter((item) => item.correo !== correo));
  };

  // Paso 4: Función para manejar el cambio en el input de agregar un correo
  const handleInputChange = (e) => {
    setNuevoCorreo(e.target.value);
  };

  // Paso 5: Función para manejar el submit del formulario
  const handleFormSubmit = (e) => {
    e.preventDefault();
    if (nuevoCorreo && !correos.some((item) => item.correo === nuevoCorreo)) {
      setCorreos([...correos, { correo: nuevoCorreo }]);
      setNuevoCorreo(""); // Limpiar el input
    }
  };

  // Paso 6: Función para guardar los correos como string
  const handleSave = () => {
    const correosString = correos.map((item) => item.correo).join(";");
    onSave(correosString); // Llama a la función onSave pasada por props
  };

  return (
    <div>
      <h3>Gestión de Correos</h3>

      {/* Mostrar la lista de correos */}
      <div>
        {correos.length > 0 ? (
          <ul>
            {correos.map((item, index) => (
              <li key={index}>
                {item.correo}{" "}
                <button onClick={() => eliminarCorreo(item.correo)}>Eliminar</button>
              </li>
            ))}
          </ul>
        ) : (
          <p>No hay correos para mostrar.</p>
        )}
      </div>

      {/* Formulario para agregar un correo */}
      <form onSubmit={handleFormSubmit}>
        <input
          type="email"
          value={nuevoCorreo}
          onChange={handleInputChange}
          placeholder="Nuevo correo"
          required
        />
        <button type="submit">Agregar</button>
      </form>

      {/* Botón para guardar los correos */}
      <button onClick={handleSave}>Guardar Correos</button>
    </div>
  );
};

export default CorreoManager;
